// @flow
import React, { Component, Fragment } from 'react'
import type { Node } from 'react'
import MultiSelect from '../controls/MultiSelect'
import styled from 'styled-components'
import WhatIsItHint from '../controls/WhatIsItHint'

const SelectWrapper = styled.div`
  width: 580px;
`
const blogLink = '/ru/blog/segmentation#post_header'

type Props = {|
  hide: boolean,
  value: Array<string>,
  onChange: (Array<string>) => void
|}

const t = {
  title: 'Сегментация',
  no_options: 'Ничего не найдено',
  placeholder: 'Выберите параметры дробления',
  location: 'По локациям',
  gender: 'По полу',
  age: 'По возрасту',
  providers: 'По сетям',
  fb_placements: 'По плейсментам Facebook',
  important_params: 'По значимым параметрам',
  targeting_sources: 'По сегментам',
  vk_apps: 'По приложениям ВКонтакте',
  vk_groups: 'По сообществам ВКонтакте',
  keywords: 'По ключевым словам',
  vk_activity: 'По активности в сообществах ВКонтакте',
  interests: 'По интересам',
  platform: 'Мобайл/десктоп',
  title_hint:
    'Сегментация позволяет в один клик создать пачку аудиторий, сегментировав по выбранным параметрам.',
  title_hint_more: 'Узнать подробнее',
  placement_type: 'По форматам'
}

export default class Segmentation extends Component<Props> {
  render() {
    if (this.props.hide) return null

    return (
      <Fragment>
        <h2 className="t-Segmentation__header">
          {t.title + ' '}
          <WhatIsItHint content={this.titleContent()} />
        </h2>
        <SelectWrapper className="t-Segmentation">
          <MultiSelect
            value={this.props.value}
            options={this.options()}
            noResultsText={t.no_options}
            placeholder={t.placeholder}
            isClearable
            onChange={(ids) => this.props.onChange(ids)}
          />
        </SelectWrapper>
      </Fragment>
    )
  }

  options() {
    return [
      { id: 'locations', name: t.location },
      { id: 'gender', name: t.gender },
      { id: 'age', name: t.age },
      { id: 'providers', name: t.providers },
      { id: 'fb_placements', name: t.fb_placements },
      { id: 'important_params', name: t.important_params },
      { id: 'targeting_sources', name: t.targeting_sources },
      { id: 'vk_apps', name: t.vk_apps },
      { id: 'vk_groups', name: t.vk_groups },
      { id: 'keywords', name: t.keywords },
      { id: 'vk_activity', name: t.vk_activity },
      { id: 'interests', name: t.interests },
      { id: 'platform', name: t.platform },
      { id: 'placement_type', name: t.placement_type }
    ]
  }

  titleContent(): Node {
    return (
      <div>
        {t.title_hint + ' '}
        <a href={blogLink} target="_blank">
          {t.title_hint_more}
        </a>
      </div>
    )
  }
}
